import type { LucideIcon } from "lucide-react";

interface ComingSoonPageProps {
  label: string;
  icon: LucideIcon;
}

export function ComingSoonPage({ label, icon: Icon }: ComingSoonPageProps) {
  return (
    <div className="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-h-full">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-text-center">
        <div className="tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-muted">
          <Icon className="tw-h-8 tw-w-8 tw-text-muted-foreground" />
        </div>
        <div>
          <h2 className="tw-text-xl tw-font-semibold">{label}</h2>
          <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">Coming Soon</p>
        </div>
      </div>
    </div>
  );
}
